<template>
  <section class="section is-medium">
      <!-- <div class="container"> -->
          <div class="columns is-centered">
              <div class="column is-5">
                  <div class="box">
                    <b-icon pack="fas" icon="user-plus" size="is-large"></b-icon>
                    <b-field label="Nombre" label-position="inside">
                        <b-input v-model="nombre"></b-input>
                    </b-field>
                    <b-field label="Contraseña" label-position="inside">
                        <b-input v-model="pass" type="password" password-reveal></b-input>
                    </b-field>
                    <b-field label="Número" label-position="inside">
                        <b-numberinput :controls="false"></b-numberinput>
                    </b-field>
                    <div class="buttons">
                        <b-button tag="router-link" :to="{ path: '/signup' }" type="is-primary" expanded>Crear cuenta</b-button>
                        <b-button type="is-success" expanded>Registrarse</b-button>
                    </div>
                </div>
              </div>
          </div>
      <!-- </div> -->
  </section>
</template>

<script>
export default {
    name: 'Login',
    data() {
        return {
            nombre: '',
            pass: ''
        }
    }
}
</script>

<style>

</style>